export type Severity =
  | 'success'
  | 'error'
  | 'warning'
  | 'info'
  | 'alert'
  | 'loading';

export enum ActionMetadataType {
  TaksAssigned = 'task_assigned',
  TaskEdited = 'task_edited',
}

export enum NotificationSection {
  Today = 'today',
  Yesterday = 'yesterday',
  Earlier = 'earlier',
}
